import React, { useEffect, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";

const WhyChooseV1 = () => {
  const [whyChooseData, setWhyChooseData] = useState(null);

  useEffect(() => {
    const fetchWhyChooseData = async () => {
      try {
        const response = await fetch(
          "https://eventscons.com/eventbackendnew/api/why-choose-us-details"
        );
        const result = await response.json();

        if (result?.status && result?.data) {
          setWhyChooseData(result.data);
        }
      } catch (error) {
        console.error("Why Choose Us API fetch error:", error);
      }
    };

    fetchWhyChooseData();
  }, []);

  if (!whyChooseData) {
    return (
      <section
        className="why-choose-us"
        style={{ backgroundColor: "#fff", overflow: "hidden", paddingTop: "0px" }}
      >
        <div className="container" style={{ padding: "80px 0" }}>
          <p>Loading...</p>
        </div>
      </section>
    );
  }

  return (
    <>
      <section
        className="why-choose-us"
        style={{ backgroundColor: "#fff", overflow: "hidden", paddingTop: "0px" }}
      >
        {/* TOP IMAGE */}
        <div style={{ width: "100%", height: "460px" }}>
          <img
            src={whyChooseData?.main_image}
            alt={whyChooseData?.main_title || "Why Choose Us"}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>

        {/* BOTTOM CONTENT */}
        <div className="container-fluid p-0">
          <div className="row g-0 align-items-stretch">
            {/* LEFT COLUMN */}
            <div
              className="col-lg-6 col-md-12 d-flex align-items-center"
              style={{ backgroundColor: "#f5f5f5", padding: "100px 8%" }}
            >
              <div className="inner-column">
                <div className="sec-title" style={{ marginBottom: "0px" }}>
                  <h2 className="mainheadingfont"
                    style={{
                      fontSize: "42px",
                      fontWeight: "700",
                      color: "#000",
                      marginBottom: "20px",
                      textAlign: "left",
                    }}
                  >
                    {whyChooseData?.main_title}
                  </h2>
                </div>

                <p className="mainparafont"
                  style={{
                    fontSize: "16px",
                    color: "#333",
                    lineHeight: "1.7",
                    marginBottom: "40px",
                    maxWidth: "450px",
                    textAlign: "left",
                  }}
                >
                  {whyChooseData?.main_description}
                </p>

                <div className="btn-box">
                  {whyChooseData?.main_button_link?.startsWith("/") ? (
                    <Link
                      to={whyChooseData.main_button_link}
                      className="theme-btn"
                      style={{
                        backgroundColor: "#000",
                        color: "#fff",
                        padding: "15px 40px",
                        textDecoration: "none",
                        fontWeight: "600",
                        display: "inline-block",
                        fontSize: "16px",
                      }}
                    >
                      {whyChooseData?.main_button_text}
                    </Link>
                  ) : (
                    <a
                      href={whyChooseData?.main_button_link}
                      className="theme-btn"
                      style={{
                        backgroundColor: "#000",
                        color: "#fff",
                        padding: "15px 40px",
                        textDecoration: "none",
                        fontWeight: "600",
                        display: "inline-block",
                        fontSize: "16px",
                      }}
                    >
                      {whyChooseData?.main_button_text}
                    </a>
                  )}
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN */}
            <div
              className="col-lg-6 col-md-12 d-flex align-items-center"
              style={{
                backgroundColor: "#262626",
                color: "#fff",
                padding: "80px 6%",
              }}
            >
              <div className="inner-column w-100">
                {whyChooseData?.child_items?.map((item, index) => (
                  <div
                    className="choose-block d-flex mb-5"
                    key={index}
                    style={{ maxWidth: "600px" }}
                  >
                    <div
                      className="icon-box"
                      style={{ marginRight: "25px", flexShrink: 0 }}
                    >
                      <img
                        src={item.child_image}
                        alt={item.child_title}
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "contain",
                          filter: "brightness(0) invert(1)",
                        }}
                      />
                    </div>

                    <div className="content">
                      <h4
                        style={{
                          fontSize: "24px",
                          fontWeight: "600",
                          marginBottom: "10px",
                        }}
                      >
                        {item.child_title}
                      </h4>

                      <p
                        style={{
                          fontSize: "15px",
                          color: "#cecece",
                          lineHeight: "1.6",
                          margin: 0,
                        }}
                      >
                        {item.child_description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseV1;